<script setup lang="ts">
import { useElementSize } from "@vueuse/core"
import { computed, useTemplateRef } from "vue"

const el = useTemplateRef("el")

const { width } = useElementSize(el)

const COLUMNS_WIDTH = 60

// génère une liste aléatoire de 15 points smooth
const getListPoints = computed(() => {
    const list = [
        12, 13, 14, 16, 18, 17, 15, 13, 10, 11, 10, 9, 11, 12, 13, 16, 17,
    ]
    return Array.from(
        { length: getLength.value },
        (_, i) => list[i % list.length]
    )
})

const getLength = computed(() => {
    return Math.floor(width.value / COLUMNS_WIDTH)
})

const getWidth = (i: number) => {
    return `${getListPoints.value[i]}rem`
}
</script>

<template>
    <div class="base-chart-skeleton flex flex-col gap-6 px-0 md:px-12" ref="el">
        <div
            class="base-chart-skeleton__list flex gap-6 overflow-hidden items-end"
        >
            <BaseSkeleton width="10px" height="20rem"></BaseSkeleton>
            <BaseSkeleton
                v-for="i in getLength"
                :key="i"
                :width="`${COLUMNS_WIDTH}px`"
                :height="getWidth(i)"
            />
        </div>
        <BaseSkeleton width="100%" height="10px"></BaseSkeleton>
        <BaseSkeleton width="100%" height="5rem"></BaseSkeleton>
    </div>
</template>
